import styled from 'styled-components';
export const Container = styled('div')`
  margin: 1em 0;
  padding: 0 1em;
  z-index: 666;
  background: #fff;
`;
